<template>
  <div>
    <el-table :data="coinList">
      <el-table-column label="币种">
        <template slot-scope="scope">
          <div class="coin-type">
            <img :src="scope.row.logo" alt="" />
            {{ scope.row.coinType }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="coinName" label="币种名称"> </el-table-column>
      <el-table-column label="投票奖励">
        <template slot-scope="scope">
          {{ scope.row.reward }} BKK
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            circle
            icon="el-icon-edit"
          ></el-button>
          <el-button
            type="danger"
            size="small"
            circle
            icon="el-icon-delete"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager-wrap">
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handlPageChanged"
      >
      </pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'CoinList',
  components: {
    Pagination
  },
  computed: {
    ...mapState('voteCoinSetting', ['coinList', 'totalCount', 'pagination'])
  },
  methods: {
    handlPageChanged(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped>
.coin-type {
  display: flex;
  align-items: center;

  img {
    width: 32px;
    height: 32px;
    vertical-align: middle;
    margin-right: 5px;
  }
}
</style>
